module.exports = __webpack_public_path__ + "media/images/icon-menu-active-7d98f6862f83146d446efd28030c688e.svg";